import cookies from 'js-cookie'
import {keys} from 'lodash'

export class CookieStore {
  constructor(private cookieName: string, private durationInMinutes: number) {}

  set(data: any) {
    cookies.set(this.cookieName, data, {
      expires: (1 / 24 / 60) * this.durationInMinutes,
    })
  }

  get() {
    let data = cookies.getJSON(this.cookieName)

    return keys(data).length > 0 ? data : null
  }

  clear() {
    cookies.remove(this.cookieName)
  }
}
